import { render } from "./RegistroSanitarioSteps.vue?vue&type=template&id=5fad890a"
import script from "./RegistroSanitarioSteps.vue?vue&type=script&lang=js"
export * from "./RegistroSanitarioSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__